import { render, staticRenderFns } from "./BaseTab.vue?vue&type=template&id=004774d6"
import script from "./BaseTab.vue?vue&type=script&lang=js"
export * from "./BaseTab.vue?vue&type=script&lang=js"
import style0 from "./BaseTab.vue?vue&type=style&index=0&id=004774d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports